import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { withStyles } from '@mui/styles';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import FullPage from './FullPage';
import { Link } from "react-router-dom";
import { Collapse, Container, ListItemButton } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

const drawerWidth = 240;

const styles = theme => ({
	root: {
		display: 'flex',
	},
	appBar: {
		// zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(['width', 'margin'], {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
		}),
	},
	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(['width', 'margin'], {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginLeft: 12,
		marginRight: 36,
	},
	hide: {
		display: 'none',
	},
	drawer: {
		zIndex: 10001,
		width: drawerWidth,
		flexShrink: 0,
		whiteSpace: 'nowrap',
		position: 'fixed',
		top: `calc(${theme.mixins.toolbar.minHeight || 64}px + 8px)`,
		left: 0,
		height: `calc(100vh - ${theme.mixins.toolbar.minHeight || 64}px - 8px)`,
	},
	drawerOpen: {
		position: 'fixed',
		width: drawerWidth,
		height: `calc(100vh - ${theme.mixins.toolbar.minHeight || 64}px - 8px)`,
		top: `calc(${theme.mixins.toolbar.minHeight || 64}px + 8px)`,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		zIndex: 10001,
		transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
		}),
	},
	drawerClose: {
		position: 'fixed',
		height: `calc(100vh - ${theme.mixins.toolbar.minHeight || 64}px - 8px)`,
		top: `calc(${theme.mixins.toolbar.minHeight || 64}px + 8px)`,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		zIndex: 10001,
		transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
		}),
		overflowX: 'hidden',
		width: theme.spacing(7) + 1,
		[theme.breakpoints.up('sm')]: {
		width: theme.spacing(9) + 1,
		},
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		padding: '0 8px',
		...theme.mixins.toolbar,
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
		overflow: 'auto',
		height: `calc(100vh - ${theme.mixins.toolbar.minHeight || 64}px - 8px - 56px)`,
		overflowY: 'auto',
		overflowX: 'hidden',
		position: 'fixed',
		top: `calc(${theme.mixins.toolbar.minHeight || 64}px + 8px)`,
		left: drawerWidth,
		right: 0,
		bottom: 56,
		boxSizing: 'border-box',
		transition: theme.transitions.create('left', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	contentClosed: {
		left: theme.spacing(7) + 1,
		[theme.breakpoints.up('sm')]: {
			left: theme.spacing(9) + 1,
		},
	},
	nested: {
        paddingLeft: theme.spacing(10),
	},
});

class MiniDrawer extends React.Component {
	state = {
		open: true,
		openSub: "equipements",
	}

	handleDrawer = () => {
		console.log('handleDrawer>> switch')
		this.setState({ open: !this.state.open });
	}

	handleAction = (link) => {
		console.log('====================================');
		console.log({link}, link.sub && !!this.state.openSub);
		console.log('====================================');
		if (link.sub) {
			this.setState({
				openSub: this.state.openSub == link.page ? "" : link.page 
			})
		} 
	};
  	render() {
    const { classes, menu, page } = this.props;
	const { openSub } = this.state;

	let drawerStyle = this.state.open ? classes.drawerOpen : classes.drawerClose

	// console.log('===============SIDEBAR PROPS=====================');
	// console.log(this.props);
	// console.log('====================================');
		return (
			<FullPage name={page} {...this.props} admin={this.props.admin} toto={this.props.toto}>
				<div className={classes.root}>
					<CssBaseline />
					
					<Drawer
						variant="permanent"
						className={classNames(classes.drawer, drawerStyle)}
						classes={{
							paper: classNames( drawerStyle),
						}}
						open={this.state.open}
					>
					{/* <div className={classes.toolbar} lgDown/> */}
						<div style={{ flexShrink: 0 }}>
							<IconButton onClick={this.handleDrawer}>
								{this.state.open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
							</IconButton>
						</div>
						<Divider />
						<List style={{ 
							overflowY: 'auto',
							overflowX: 'hidden',
							flexGrow: 1,
							flexShrink: 1,
							minHeight: 0
						}}>

							{menu.map( link => (
								<React.Fragment key={link?.page || link?.to}>
									{!link?.sub ?
										(link?.to ? (
										<Link className="" to={link?.to}>
											<ListItemButton button selected={page === link?.page}>
											<ListItemIcon >{link?.icon}</ListItemIcon>
											<ListItemText >
												{link?.default}
											</ListItemText>
											</ListItemButton>
										</Link>									
										) : (
										<ListItemButton button selected={page === link?.page}>
											<ListItemIcon >{link?.icon}</ListItemIcon>
											<ListItemText >
												{link?.default}
											</ListItemText>
										</ListItemButton>
										))
									:
										<>
											<ListItemButton button key={link?.page} selected={page === link?.page} onClick={() => this.handleAction(link)}>
												<ListItemIcon >{link?.icon}</ListItemIcon>
												<ListItemText >
													{link?.default}
												</ListItemText>
											</ListItemButton>
											<Collapse in={true} timeout="auto" unmountOnExit>
												<List component="div" disablePadding>
													{link?.sub?.map(sub => (
														(sub?.to ? (
														<Link key={sub?.page || sub?.to} className="" to={sub?.to}>
														<ListItemButton 
															button 
															selected={page === sub.page}
															className={classes.nested}
														>
															{/* <ListItemIcon >{sub.icon}</ListItemIcon> */}
															<ListItemText style={{textAlign:"right"}} >
																{sub?.default}
															</ListItemText>
														</ListItemButton>
														</Link>		
														) : (
														<ListItemButton 
															key={sub?.page || sub?.default}
															button 
															selected={page === sub.page}
															className={classes.nested}
														>
															<ListItemText style={{textAlign:"right"}} >
																{sub?.default}
															</ListItemText>
														</ListItemButton>
														))
													))}
												</List>
											</Collapse>
										</>
									}
								</React.Fragment>
							))}
						</List>
					</Drawer>
					<main className={classNames(
						classes.content,
						!this.state.open && classes.contentClosed
					)}>
						{/* <div className={classes.toolbar} /> */}
						<Container maxWidth="xl">
							{this.props.children}
						</Container>
					</main>
				</div>
			</FullPage>
		
		)
	}
}

MiniDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(MiniDrawer);
